
export default {
  methods: {
    SET_TO_SCROLL_TOP() {
      window.scrollTo(0, 0)
    },
  },
}
